<template>
  <div class="dashboard-card">
    <div class="dashboard-card__header">
      <div class="dashboard-card__title">Historial de envios</div>
      <CButton size="sm" color="info" variant="ghost" @click="$emit('open-history')">
        Ver todo
      </CButton>
    </div>

    <div v-if="!items.length" class="dashboard-empty">
      No hay historial de envios
    </div>

    <div v-else class="history-list">
      <div v-for="item in items" :key="item.id" class="history-item">
        <div class="history-item__main">
          <div class="history-item__meta">{{ item.dateText }} {{ item.timeText }}</div>
          <div class="history-item__type">{{ item.typeLabel }}</div>
          <div class="history-item__extra">Destinatarios: {{ item.recipients }} | Estado: {{ item.statusLabel }}</div>
        </div>
        <CButton size="sm" color="secondary" @click="openItem(item)">Detalle</CButton>
      </div>
    </div>

    <CModal :show.sync="showDetailModal" title="Detalle del envio" color="info" size="lg" class="basic-modal-color">
      <div v-if="selectedItem" class="history-detail">
        <div class="history-detail__line"><strong>Fecha:</strong> {{ selectedItem.dateText }} {{ selectedItem.timeText }}</div>
        <div class="history-detail__line"><strong>Tipo:</strong> {{ selectedItem.typeLabel }}</div>
        <div class="history-detail__line"><strong>Estado:</strong> {{ selectedItem.statusLabel }}</div>

        <div class="history-detail__totals">
          <div class="history-detail__total-item">
            <span>Enviados</span>
            <strong>{{ selectedItem.totals.sent }}</strong>
          </div>
          <div class="history-detail__total-item">
            <span>Entregados</span>
            <strong>{{ selectedItem.totals.delivered }}</strong>
          </div>
          <div class="history-detail__total-item">
            <span>Leidos</span>
            <strong>{{ selectedItem.totals.read }}</strong>
          </div>
          <div class="history-detail__total-item">
            <span>Con error</span>
            <strong>{{ selectedItem.totals.failed }}</strong>
          </div>
        </div>
      </div>

      <template #footer>
        <CButton color="secondary" @click="showDetailModal = false">Cerrar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import deliveryHistoryService from '@/services/dashboard/delivery_history_dashboard'

export default {
  name: 'DeliveryHistoryCard',
  props: {
    eventId: { type: [String, Number], required: true },
    refreshToken: { type: Number, default: 0 }
  },
  data() {
    return {
      items: [],
      showDetailModal: false,
      selectedItem: null
    }
  },
  watch: {
    eventId: {
      immediate: true,
      handler() {
        this.loadHistory()
      }
    },
    refreshToken() {
      this.loadHistory()
    }
  },
  methods: {
    async loadHistory() {
      this.items = await deliveryHistoryService.get(this.eventId)
    },
    openItem(item) {
      this.selectedItem = item
      this.showDetailModal = true
    }
  }
}
</script>

<style scoped>
.dashboard-card {
  height: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #dfe7df;
  background: #fff;
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.08);
}

.dashboard-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.dashboard-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
}

.dashboard-empty {
  font-size: 13px;
  color: #6b7280;
  padding: 16px 0;
}

.history-list {
  max-height: 340px;
  overflow-y: auto;
}

.history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #edf1ed;
  padding: 10px 0;
}

.history-item:last-child {
  border-bottom: none;
}

.history-item__meta {
  font-size: 11px;
  color: #6b7280;
}

.history-item__type {
  font-size: 13px;
  color: #1f2937;
  font-weight: 600;
}

.history-item__extra {
  font-size: 12px;
  color: #4b5563;
}

.history-detail__line {
  margin-bottom: 8px;
  font-size: 13px;
  color: #374151;
}

.history-detail__totals {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.history-detail__total-item {
  border: 1px solid #e5ece5;
  border-radius: 10px;
  background: #f8fbf8;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}

.history-detail__total-item strong {
  font-size: 16px;
  color: #1f2937;
}

@media (max-width: 767px) {
  .history-item {
    align-items: flex-start;
    flex-direction: column;
  }

  .history-detail__totals {
    grid-template-columns: 1fr;
  }
}
</style>
